import React from 'react'
import './Footer.css'

export default function Footer() {
    return (
        <div className='footer' >
            <div className='footercontener' >
                <div>
                    <h2>General</h2>
                    <p>Home</p>
                    <p>Sign Up</p>
                    <p>Businesses / Restaurateurs</p>
                    <p>Advertising</p>
                    <p>About KindMeal.my</p>
                    <p>Help & FAQ</p>
                    <p>Terms & Conditions</p>
                    <p>Inspiring Partners</p>
                    <p>Lifestyle Ambassadors</p>
                    <p>Jobs & Careers</p>
                    <p>Contact Us</p>
                </div>
                <div>
                    <h2>Features</h2>
                    <p>Meat-Free Deals</p>
                    <p>Tasty Menus</p>
                    <p>Kind Moments</p>
                    <p>Meat-Free Recipes</p>
                    <p>Member Recommendations</p>
                    <p>Featured Restaurants</p>
                    <p>Vegetarian & Vegan Directory</p>
                    <p>Food Map</p>
                    <p>Become A Superhero</p>
                    <p>Vegan News & Vegetarian Articles</p>
                    <p>Latest Comments</p>
                </div>
                <div>
                    <h2>Social Media</h2>
                    <p>KindMeal Widget</p>
                    <p>Facebook</p>
                    <p>Twitter</p>
                    <p>Instagram</p>
                </div>
                <div>
                    <h2>Mobile</h2>
                    <p>iPhone & iPod App</p>
                    <p>Android App</p>
                    <br />
                    <p>Exciting Promos</p>
                    <p>Gadhimai: Ending Mass Slaughter</p>
                    <p>Free Meals</p>
                    <p>Food Bloggers</p>
                    <p>Uber CHIRP</p>
                    <p>Jane Goodall Contest</p>
                    <p>Win Digi iPhone 6</p>
                    <p>Feed The Poor</p>
                    <p>Win Superhero Gifts</p>
                    <p>Win an iPad Mini 3</p>
                </div>
                <div>
                    <h2>PetFinder.my</h2>
                    <p>Adopt A Pet</p>
                    <p>Smartphone Apps</p>
                    <p>WAGazine</p>
                    <p>Discussion Forum</p>
                    <p>Medical Fund</p>
                </div>
            </div>
            <p style={{textAlign:'center'}} >Copyright © KindMeal.my, 2014 - 2022. All rights reserved.</p>
            <p style={{textAlign:'center'}} >This website promotes compassionate, meat-free dining experience. Some food may contain eggs, dairy products or alcohol, please view individual listings for details.</p>
        </div>
    )
}
